import { flatten, get, map } from 'lodash'

const getIncludedAllergensOfId = (id, flattenedAllergenOptionsGroupedById) =>
  flatten(
    map(
      get(
        flattenedAllergenOptionsGroupedById,
        `${id}[0].includedAllergens`,
        [],
      ),
      includedAllergenId => [
        includedAllergenId,
        ...flatten(
          getIncludedAllergensOfId(
            includedAllergenId,
            flattenedAllergenOptionsGroupedById,
          ),
        ),
      ],
    ),
  )

export default getIncludedAllergensOfId
